module.exports = __webpack_public_path__ + "img/1f90660.png";